import { gql } from "@apollo/client"

export const ASSIGNED_TRIP_BOOKING_FRAG = gql`
  fragment AssignedTripBookingFrag on BookingType {
    id
    schedule {
      id
      variety {
        id
        name
        commodity {
          id
          name
        }
      }
      plotCommodity {
        id
        name
      }
      gatePass
      sourceDepot {
        id
        name
        location {
          id
          latitude
          longitude
          village
        }
      }
      destinationDepot {
        id
        name
        location {
          id
          latitude
          longitude
          village
        }
      }
      plot {
        id
        name
        farmer {
          id
          fullName
        }
        address {
          id
          latitude
          longitude
          village
          taluka
        }
      }
    }
    procuredQuantity
    requiredQuantity
  }
`
export const ASSIGNED_TRIP_LIST_FRAG = gql`
  fragment AssignedTripListFrag on TripType {
    id
    uuid
    status
    date
    aggregator {
      id
      fullName
      number
    }
    sourceDepot {
      id
      name
      location {
        id
        latitude
        longitude
      }
    }
    destinationDepot {
      id
      name
      location {
        id
        latitude
        longitude
      }
    }
    vehicle {
      id
      driver {
        id
        number
        fullName
      }
      owner {
        id
        number
        fullName
      }
      registrationNumber
      vehicleType {
        id
        name
        category
      }
    }
  }
`

export const ASSIGNED_TRIP_MAP_FRAG = gql`
  fragment AssignedTripMapFrag on TripType {
    id
    uuid
    status
    aggregator {
      id
      fullName
      number
    }
    vehicle {
      id
      registrationNumber
      vehicleType {
        id
        name
      }
    }
    bookings {
      id
      procuredQuantity
      requiredQuantity
    }
  }
`
export const ASSIGNED_TRIP_DETAILS_FRAG = gql`
  fragment AssignedTripDetailsFrag on TripType {
    ...AssignedTripListFrag
    unloadedBy {
      id
      name
    }

    bookings {
      ...AssignedTripBookingFrag
    }
  }
  ${ASSIGNED_TRIP_LIST_FRAG}
  ${ASSIGNED_TRIP_BOOKING_FRAG}
`
